import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { MatchStatus } from '../../../../../services/interfaces';
import { setCssVariant, printPenalty } from '../../helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchPostPenaltiesScore = ({ state }: Props) => {
  const size = state.size;
  const cssVariant = setCssVariant(size);

  const match = state.matchData;
  if (!match || match.status !== MatchStatus.FINISHED) return null;

  const penaltyResult: string = printPenalty(match, false);

  if (!penaltyResult) return null;

  return (
    <div class={{ 'pk-match__post--penalties-score': true, ...cssVariant }} part="match-post-penalties">
      {penaltyResult}
    </div>
  );
};

export { MatchPostPenaltiesScore };
